export default __webpack_public_path__ + "static/media/credit_Card_Auth.fb65cd2c.pdf";